module.exports = __webpack_public_path__ + "static/media/4150.f838ff32.jpg";